"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = exports.chipColors = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Icon_1 = require("../../foundations/IconV2/Icon");
const TextV2_1 = require("../../foundations/Typography/TextV2");
const Target_1 = require("../Target");
exports.chipColors = {
    neutral: {
        backgroundColor: "surface-neutral-secondary",
        color: "control-enabled",
        ":hover": {
            backgroundColor: "surface-neutral-secondary",
            color: "control-hover"
        },
        ":active": {
            backgroundColor: "surface-neutral-secondary",
            color: "control-click"
        }
    },
    critical: {
        backgroundColor: "feedback-surface-critical",
        color: "feedback-onSurface-critical",
        ":hover": {
            backgroundColor: "feedback-surface-critical",
            color: "feedback-onSurface-critical-hover"
        },
        ":active": {
            backgroundColor: "feedback-surface-critical",
            color: "feedback-onSurface-critical-click"
        }
    },
    warning: {
        backgroundColor: "feedback-surface-warning",
        color: "feedback-onSurface-warning",
        ":hover": {
            backgroundColor: "feedback-surface-warning",
            color: "feedback-onSurface-warning-hover"
        },
        ":active": {
            backgroundColor: "feedback-surface-warning",
            color: "feedback-onSurface-warning-click"
        }
    },
    success: {
        backgroundColor: "feedback-surface-success",
        color: "feedback-onSurface-success",
        ":hover": {
            backgroundColor: "feedback-surface-success",
            color: "feedback-onSurface-success-hover"
        },
        ":active": {
            backgroundColor: "feedback-surface-success",
            color: "feedback-onSurface-success-click"
        }
    },
    info: {
        backgroundColor: "feedback-surface-info",
        color: "feedback-onSurface-info",
        ":hover": {
            backgroundColor: "feedback-surface-info",
            color: "feedback-onSurface-info-hover"
        },
        ":active": {
            backgroundColor: "feedback-surface-info",
            color: "feedback-onSurface-info-click"
        }
    },
    brand: {
        backgroundColor: "surface-brand",
        color: "onSurface-brand-primary",
        ":hover": {
            backgroundColor: "surface-brand",
            color: "onSurface-brand-primary-hover"
        },
        ":active": {
            backgroundColor: "surface-brand",
            color: "onSurface-brand-primary-click"
        }
    }
};
const Chip = (props) => {
    const { label, size = "large", type = "neutral", icon, onDismiss, disabled = false } = props;
    const layoutStyles = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "spacing-2",
        width: "max-content"
    };
    const appearanceStyles = react_1.default.useMemo(() => ({
        borderRadius: "radius-round",
        padding: size === "large" ? "spacing-3" : "spacing-2",
        height: size === "large" ? "spacing-8" : "spacing-7"
    }), [size]);
    const textVariant = react_1.default.useMemo(() => {
        return size === "large" ? "body-2-medium" : "caption";
    }, [size]);
    const colorStyles = react_1.default.useMemo(() => (Object.assign(Object.assign({}, exports.chipColors[type]), { ":focus-visible": {
            outline: "2px solid",
            outlineColor: "focus",
            outlineOffset: "2px"
        } })), [type]);
    const disabledStyles = react_1.default.useMemo(() => {
        if (disabled) {
            return {
                backgroundColor: "surface-neutral-secondary",
                color: "text-input-disabled",
                ":hover": {
                    backgroundColor: "surface-neutral-secondary"
                },
                ":active": {
                    backgroundColor: "surface-neutral-secondary"
                },
                ":focus-visible": {
                    backgroundColor: "surface-neutral-secondary"
                }
            };
        }
        return {};
    }, [disabled]);
    return (react_1.default.createElement(foundations_1.Box, { tabIndex: 0, sx: Object.assign(Object.assign(Object.assign(Object.assign({}, colorStyles), layoutStyles), disabledStyles), appearanceStyles), disabled: disabled },
        icon && react_1.default.createElement(Icon_1.IconV2, { size: "xxs", color: "currentColor", icon: icon }),
        react_1.default.createElement(TextV2_1.TextV2, { variant: textVariant, weight: "medium" }, label),
        onDismiss && (react_1.default.createElement(Target_1.Target, { sx: Object.assign(Object.assign({}, colorStyles), { marginTop: "spacing-2" }), "aria-label": "Dismiss", onClick: onDismiss },
            react_1.default.createElement(Icon_1.IconV2, { color: "currentColor", size: "xxs", icon: "x" })))));
};
exports.Chip = Chip;
//# sourceMappingURL=Chip.js.map